import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field } from "formik";
import { isEmpty, get } from "lodash";
import React from "react";
import { useState } from "react";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInputDollar,
  SearchableList,
} from "../../../components";
import {
  returnOnlyIfBoolean,
  yesNoOptions,
  getWithdrawalName,
  getHardshipReason,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  DISTRIBUTION_WITHDRAWAL_TYPE,
  clearFieldValues,
} from "../../../utils";
import { withdrawalTypeEnum } from "./DistributionConstantsAndFunctions";

function BasicDetailsCard(props) {
  const {
    fields,
    withdrawalRequestId,
    values,
    style = {},
    className = "",
    employeePlans,
    selectedPlan,
    setValues,
    setFieldValue,
    handleChange,
    selectModePaymentError,
    max,
    min,
    selectedWithdrawalPlanSetUp,
    initialValues,
    calculateMaximumWithDrawalAmount,
    ...rest
  } = props;

  const onWithDrawalChange = (value, label) => {
    const selectedWithdrawal = employeePlans[selectedPlan].withdrawals.find(
      (_) => _.id === value
    );

    const tempValues = {
      ...initialValues,
      [fields.withdrawalType]: selectedWithdrawal.withDrawalType,
      [fields.modeOfPayment]: 1,
      [fields.withdrawalTransactions]: [],
      [fields.withdrawalName]: label,
      [fields.withdrawalId]: selectedWithdrawal.id,
      [fields.withdrawEntireAmount]: true,
      // [fields.netAmountRequested]: parseFloat(max),
      [fields.withdrawalFee]:
        employeePlans[selectedPlan]?.withdrawals[value]
          ?.withdrawalOneTimeOriginateFee,
      [fields.modeOfPayment]: 1,
      [fields.withdrawalFee]:
        selectedWithdrawal.withDrawalType ==
        DISTRIBUTION_WITHDRAWAL_TYPE.Hardship
          ? selectedWithdrawal.hardshipWithdrawalFee
          : selectedWithdrawal.withdrawalOneTimeOriginateFee,
    };
    tempValues[fields.netAmountRequested] = parseFloat(
      calculateMaximumWithDrawalAmount(tempValues)
    );

    setValues(tempValues);
  };
  const onWithdrawEntireAmountChange = (value, values) => {
    let tempValues = { ...values };
    tempValues[fields.withdrawEntireAmount] = value;
    if (value === false) {
      tempValues[fields.netAmountRequested] = "";
    } else if (value === true) {
      tempValues[fields.netAmountRequested] = calculateMaximumWithDrawalAmount(
        tempValues
      );
    }
    return tempValues;
  };
  const withdrawAsOptions =
    values[fields.withdrawalType] ===
      withdrawalTypeEnum.SeparationFromService &&
    get(employeePlans, `${selectedPlan}.withdrawals`, []).find(
      (_) => _.id === values[fields.withdrawalId]
    )?.periodicPaymentApplicable === true
      ? [
          {
            label: "One time Payment",
            value: 1,
          },
          {
            label: "Periodic Payment",
            value: 2,
          },
        ]
      : [
          {
            label: "One time Payment",
            value: 1,
          },
        ];
  const withdrawalTypeOptions =
    employeePlans[selectedPlan] &&
    employeePlans[selectedPlan].withdrawals?.map((val, index) => ({
      label:
        val.withDrawalType == 2
          ? `${getWithdrawalName(val.withDrawalType)}${getHardshipReason(
              val.hardshipReason
            )}`
          : `${getWithdrawalName(val.withDrawalType)}${
              val.withdrawalDescription
            }`,
      value: val.id,
    }));
  return (
    <div style={{ ...style }} className={className}>
      <div className="heading-div">Basic Details</div>
      <div className="basic-details-card" style={{ marginBottom: "20px" }}>
        <p className="body_color">Withdrawal Type</p>
        <Field
          size="md"
          name={fields.withdrawalName}
          selectedValue={values[fields.withdrawalId]}
          value={values[fields.withdrawalId]}
          direction="right"
          placeholder="Select a withdrawal type"
          disabled={!isEmpty(withdrawalRequestId)}
          options={withdrawalTypeOptions}
          popupContent={
            <SearchableList
              label="Select a withdrawal type"
              options={withdrawalTypeOptions}
              onSelect={(value, label) => {
                onWithDrawalChange(value, label);
              }}
              selectedValue={values[fields.withdrawalId]}
            />
          }
          validate={(value) => {
            return [undefined, null, ""].includes(values[fields.withdrawalId])
              ? "WL001 : Required"
              : undefined;
          }}
          offset={140}
          component={FieldDropSide}
        />
        {values[fields.withdrawalId] && (
          <div>
            <p className="rollOverErrorStyle"> {selectModePaymentError} </p>
            <p className="body_color">Withdraw as</p>
            <Field
              // isRequired
              name={fields.modeOfPayment}
              size="xl"
              options={withdrawAsOptions}
              selectedValue={values[fields.modeOfPayment]}
              onChange={(value) => {
                let tempValues = { ...values };
                tempValues[fields.modeOfPayment] = value;
                tempValues[fields.periodicPaymentType] = "";
                tempValues[fields.withdrawalTransactions] = [];
                tempValues = onWithdrawEntireAmountChange(true, tempValues);
                setValues(tempValues);
              }}
              //disabled={isEdit && !isSave}
              validate={(value) => {
                return [undefined, null, ""].includes(value)
                  ? "WL002 : Required"
                  : undefined;
              }}
              component={FieldButtonGroup}
            />

            {values[fields.modeOfPayment] && (
              <div>
                <p className="body_color">
                  Withdraw entire balance
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    style={{ fontSize: "16px" }}
                    className="ml-2"
                    color="#828282"
                  />
                </p>
                <Field
                  // isRequired
                  name={fields.withdrawEntireAmount}
                  size="sm"
                  options={yesNoOptions}
                  selectedValue={returnOnlyIfBoolean(
                    values[fields.withdrawEntireAmount]
                  )}
                  onChange={(value) => {
                    setValues(onWithdrawEntireAmountChange(value, values));
                  }}
                  disabled={
                    values[fields.modeOfPayment] === 2 ||
                    values[fields.withdrawalType] === withdrawalTypeEnum.QBAD
                  }
                  component={FieldButtonGroup}
                />

                {/* {values[fields.withdrawEntireAmount] === true ? (
                  <p className="body_color"> Amount </p>
                ) : (
                  <p className="body_color"> Net amount</p>
                )}
                <Field
                  // isRequired
                  name={fields.netAmountRequested}
                  size="sm"
                  value={values[fields.netAmountRequested]}
                  onChange={handleChange}
                  disabled={values[fields.withdrawEntireAmount] === true}
                  // min={min}
                  // max={max}
                  preventNegative={true}
                  component={FieldInputDollar}
                  validate={(value) => {
                    return [undefined, null, ""].includes(value)
                      ? "Required"
                      : values[fields.netAmountRequested] > max
                      ? `The Requested amount should be equal to or lesser than ${max}`
                      : values[fields.netAmountRequested] < min
                      ? `The Requested amount should be equal to or greater than ${min}`
                      : "";
                  }}
                /> */}
                <p className="body_color">
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    style={{ fontSize: "16px", marginRight: "2px" }}
                    color="#828282"
                  />
                  Min - $ {min} Max - $ {max}
                </p>

                <p className="body_color">Overall Withdrawal Fee</p>
                <Field
                  isRequired
                  name={fields.withdrawalFee}
                  size="sm"
                  selectedValue={values[fields.withdrawalFee]}
                  onChange={handleChange}
                  preventNegative={true}
                  //disabled={isEdit && !isSave}
                  validate={(value) => {
                    return [undefined, null, ""].includes(value)
                      ? "Required"
                      : undefined;
                  }}
                  component={FieldInputDollar}
                />
                {values[fields.modeOfPayment] === 2 && (
                  <div>
                    <p className="body_color">Periodic Payment</p>
                    <Field
                      size="md"
                      name={fields.periodicPaymentType}
                      value={values[fields.periodicPaymentType]}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.PERIODIC_PAYMENT_OPTIONS
                      ).filter((_) =>
                        get(
                          selectedWithdrawalPlanSetUp,
                          "calculationMethods",
                          []
                        ).includes(_.value)
                      )}
                      onChange={(value) => {
                        setFieldValue(fields.periodicPaymentType, value);
                      }}
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "Required"
                          : undefined;
                      }}
                      popupContent={
                        <SearchableList
                          label="Select a periodic payment type"
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.PERIODIC_PAYMENT_OPTIONS
                          ).filter(
                            (_) =>
                              get(
                                selectedWithdrawalPlanSetUp,
                                "calculationMethods",
                                []
                              ).includes(_.value) && _.value !== 4
                          )}
                          onSelect={(value) => {
                            let updatedValues = clearFieldValues({
                              values,
                              fieldsToClear: [
                                fields.netPeriodicPaymentAmount,
                                fields.typeOfExpectancy,
                                fields.dateOfAnnuityPayments,
                                fields.frequency,
                                fields.nextRepaymentDate,
                                fields.numberOfInstallments,
                              ],
                            });
                            updatedValues[fields.periodicPaymentType] = value;
                            setValues(updatedValues);
                          }}
                          selectedValue={values[fields.periodicPaymentType]}
                        />
                      }
                      offset={140}
                      component={FieldDropSide}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default BasicDetailsCard;
